const { NODE_ENV: ENV } = process.env
const API = process.env.REACT_APP_API_PROD;
const APIDEV = process.env.REACT_APP_API_DEV;

export const uAPI = API;
